import { defineMessages } from "react-intl";
const messages = defineMessages({
    organizationTitle: {
        id: "app.admin.addOrganization.title.text",
        defaultMessage: "Create Organization",
    },
    organizationName: {
        id: "app.admin.addOrganization.name.text",
        defaultMessage: "Organization Name",
    },
    organizationDomain: {
        id: "app.admin.addOrganization.domain.text",
        defaultMessage: "Domain (for SSO)",
    },
    organizationNameLength: {
        id: "app.admin.addOrganization.nameLength.text",
        defaultMessage: "Name should contain at least 5 characters",
    },
    organizationNameRequired: {
        id: "app.admin.addOrganization.nameRequired.text",
        defaultMessage: "Name is required",
    },
    organizationDomainInvalid: {
        id: "app.admin.addOrganization.domainInvalid.text",
        defaultMessage: "Please enter valid domain",
    },
    organizationDomainRequired: {
        id: "app.admin.addOrganization.domainRequired.text",
        defaultMessage: "Domain is required",
    },
    organizationSuccessCreation: {
        id: "app.admin.createOrganization.success.text",
        defaultMessage: "Organization created successfully",
    },
});
export default messages;
